<template>
    <section class="youtubesection"  :class="{'youtubeplayercss': youtubeplayertheme==='youtubeplayercss'}">
        <div class="container youtubecss">
          <div v-html="topmessage" class="toptext"></div>
            <div class="row">
                <div class="youtubecol">
                    <!-- <YouTube :src="`${youtubevideopath}`" ref="youtube" class="changewidth" /> -->
                    <video-player
                    :src="`${youtubevideopath}`"
                    :poster="`${coverpage}`"
                    controls="controls"
                    :loop="true"
                    :muted="true"
                    :volume="0.6"
                    aspectRatio="2:1"
                    :options="playerOptions"
                    class="videocss"
                   
                    />

    <!-- ...
         :poster="`${coverpage}`"
    @mounted="..."
    @ready="..."
    @play="..."
    @pause="..."
    @ended="..."
    @seeking="..."
    ... -->
                </div>
            </div>
           
        </div>
    </section>
    
    <!-- https://www.youtube.com/watch?v=jNQXAC9IVRw -->
</template>

<script>
  import { defineComponent } from 'vue'
  import { VideoPlayer } from '@videojs-player/vue'
  import 'video.js/dist/video-js.css'
  require('@/globalDeclare.js');

  export default defineComponent({
    props: ['youtubevideopath', 'coverpage', 'topmessage', 'youtubeplayertheme'],
    components: {
      VideoPlayer
    },
  })
</script>
<style scoped>
.youtubecol {
    width: 100%;

}
.youtubesection {
    background-color: whitesmoke;
}

.toptext {
  padding-bottom: 100px;
}

@media only screen and (max-width: 600px) {
.youtubecss {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  padding-bottom: 100px;
}
.videocss {
  width: 460px;
}
}

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .youtubecss {
    width: 100%;
    text-align: center;
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .videocss {
    width: 460px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .videocss {
    width: 900px;
  }
 }

 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .videocss {
    width: 1000px;
  }

  .youtubecss {
    padding-top: 100px;
    padding-bottom: 100px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

  /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {

}
</style>